export default "__VITE_ASSET__M31bj_rQ__"